import walletBook from '../../wallet-book.js';

const useWalletBook = () => walletBook;

export { useWalletBook };
